(function () {
  var root = document.querySelector("[data-spd-eu]");
  if (!root) return;

  // Formatters (EUR)
  var C0 = (n) =>
    new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(n);
  var C2 = (n) =>
    new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 2,
    }).format(n);
  var q = (s) => root.querySelector(s);

  // Prices (your numbers)
  var BASE = parseFloat(root.getAttribute("data-unit-price")) || 2999; // live lowest GM2 unit (ex VAT)
  var RETAIL_EX = BASE; // EU store prices are ex-VAT
  var FALLBACK_RATE = 20; // only used if the shared VAT engine is missing

  // Reused-section variant reactivity: inert by default (nothing dispatches
  // this event on GM2 today), lets a page update the unit price used by the
  // calculator when the customer picks a different variant. Price is in the
  // same major-unit currency as data-unit-price/RETAIL_EX (euros), not cents.
  document.addEventListener("spx:calc:unit-price", function (e) {
    var p = parseFloat(e && e.detail && e.detail.price);
    if (!p || !isFinite(p) || p <= 0) return;
    RETAIL_EX = p;
    if (root) root.setAttribute("data-unit-price", String(p));
    try {
      compute();
    } catch (err) {}
  });

  // VAT basis and rate both come from the site-wide engine (window.SPXVat,
  // assets/vat-display.js) so this calculator can never disagree with the price
  // shown elsewhere on the page. Read lazily: the engine is a deferred head
  // script and may not exist yet (or at all) when this file first runs.
  function vatEngine() {
    var v = window.SPXVat;
    return v && typeof v.applyRate === "function" ? v : null;
  }

  function vatRate() {
    var v = vatEngine();
    return v && typeof v.rate === "number" ? v.rate : FALLBACK_RATE;
  }

  // State
  var members = 2,
    years = 3,
    mode = "pt",
    travel = "public",
    timeOn = true,
    childcareOn = true,
    tripsWk = 3,
    ptPerW = 1;

  // Presets (editable later if you want to fine-tune)
  var PRESETS = {
    EU: {
      gym: 32,
      pt: 65,
      trips: 3,
      fare: 3.5,
      mins_pub: 40,
      km: 10,
      ppk: 0.5,
      mins_car: 40,
      vhr: 22,
    },
    CH: {
      gym: 65,
      pt: 90,
      trips: 3,
      fare: 4.0,
      mins_pub: 40,
      km: 10,
      ppk: 0.75,
      mins_car: 40,
      vhr: 30,
    },
    NL: {
      gym: 35,
      pt: 60,
      trips: 3,
      fare: 3.2,
      mins_pub: 38,
      km: 8,
      ppk: 0.5,
      mins_car: 35,
      vhr: 22,
    },
    AT: {
      gym: 30,
      pt: 55,
      trips: 3,
      fare: 2.8,
      mins_pub: 35,
      km: 8,
      ppk: 0.5,
      mins_car: 35,
      vhr: 20,
    },
    BE: {
      gym: 35,
      pt: 60,
      trips: 3,
      fare: 3.0,
      mins_pub: 38,
      km: 8,
      ppk: 0.5,
      mins_car: 35,
      vhr: 22,
    },
  };

  // Outputs
  var O = {
    hero: q('[data-out="hero"]'),
    mon: q('[data-out="month"]'),
    brk: q('[data-out="break"]'),
    per: q('[data-out="per"]'),
    tSpd: q('[data-out="t-spd"]'),
    tGym: q('[data-out="t-gym"]'),
    tSav: q('[data-out="t-save"]'),
    p1: q('[data-out="p1"]'),
    p2: q('[data-out="p2"]'),
    p3: q('[data-out="p3"]'),
    barS: q('[data-out="bar-s"]'),
    barG: q('[data-out="bar-g"]'),
    vS: q('[data-out="v-s"]'),
    vG: q('[data-out="v-g"]'),
    modeLbl: q('[data-out="mode-lbl"]'),
    barLbl: q('[data-out="bar-lbl"]'),
    breakdown: q('[data-out="breakdown"]'),
    vatBasis: q('[data-out="vat-basis"]'),
  };

  // Inputs
  var I = {
    country: q('select[name="country"]'),
    people: q('[data-role="people"]'),
    mode: q('[data-role="mode"]'),
    years: q('[data-role="years"]'),
    travel: q('select[name="travel"]'),
    time: q('[data-role="time"]'),
    child: q('[data-role="child"]'),
    trips: q('[data-role="trips"]'),

    gym: q('input[name="gym"]'),
    pt: q('input[name="pt"]'),
    ptw: q('[data-role="ptw"]'),

    fare: q('input[name="fare"]'),
    mins_pub: q('input[name="mins_pub"]'),

    km: q('input[name="km"]'),
    ppk: q('input[name="ppk"]'),
    mins_car: q('input[name="mins_car"]'),

    vhr: q('input[name="vhr"]'),
  };

  function setOn(container, btn) {
    container
      .querySelectorAll(".chip")
      .forEach((x) => x.classList.remove("is-on"));
    btn.classList.add("is-on");
  }

  function showScope(kind) {
    var pub = root.querySelectorAll('[data-scope="public"]');
    var car = root.querySelectorAll('[data-scope="car"]');
    if (!pub || !car) return;
    if (kind === "public") {
      if (pub.length > 0) {
        pub.forEach((p) => (p.style.display = "grid"));
      }

      if (car.length > 0) {
        car.forEach((c) => (c.style.display = "none"));
      }
    } else {
      if (pub.length > 0) {
        pub.forEach((p) => (p.style.display = "none"));
      }

      if (car.length > 0) {
        car.forEach((c) => (c.style.display = "grid"));
      }
    }
  }

  // Speediance price used by the model, in major units.
  function spdPrice() {
    var v = vatEngine();
    // Engine missing: keep this section's previous behaviour (incl. VAT at 20%).
    if (!v) return Math.round(RETAIL_EX * (1 + FALLBACK_RATE / 100));
    // rate-0 markets force `enabled` to false, so they land here and stay ex-VAT.
    if (!v.enabled) return RETAIL_EX;
    var inc = v.applyRate(Math.round(RETAIL_EX * 100));
    return Number.isFinite(inc) ? inc / 100 : RETAIL_EX;
  }

  function vatBasisLabel() {
    var v = vatEngine();
    var term = (v && v.taxTerm) || "VAT"; // localised (BTW / MwSt. / IVA ...)
    if (!v) return "Incl. " + term + " (" + FALLBACK_RATE + "%)";
    if (v.available === false) return "Excl. " + term;
    return v.enabled ? "Incl. " + term + " (" + vatRate() + "%)" : "Excl. " + term + " (B2B)";
  }

  function compute() {
    var gymFee = +I.gym.value || 0; // per person per month
    var ptRate = +I.pt.value || 0; // per session

    if (mode === "gym") ptPerW = 0;

    // Annual base costs
    var membershipAnnual = gymFee * 12 * members;
    var ptAnnual = ptRate * ptPerW * 52 * members;

    // Travel + time
    var travelAnnual = 0,
      travelDesc = "",
      mins = 0;
    if (travel === "public") {
      var fare = +I.fare.value || 0;
      travelAnnual = fare * tripsWk * 52 * members;
      mins = +I.mins_pub.value || 0;
      travelDesc =
        "Public transport: " + C2(fare) + "/trip × " + tripsWk + "/wk";
    } else {
      var km = +I.km.value || 0;
      var ppk = +I.ppk.value || 0;
      travelAnnual = km * ppk * tripsWk * 52 * members;
      mins = +I.mins_car.value || 0;
      travelDesc =
        "Car: " + km + " km/rt × " + C2(ppk) + "/km × " + tripsWk + "/wk";
    }

    var timeAnnual = 0,
      timeDesc = "";
    if (timeOn) {
      var vhr = +I.vhr.value || 0;
      timeAnnual = (mins / 60) * vhr * tripsWk * 52 * members;
      timeDesc = "Time: " + mins + " min/rt × " + C2(vhr) + "/hr";
    }

    var childAnnual = childcareOn ? 1.5 * 10 * 52 : 0;
    var childDesc = childcareOn ? "Childcare: €10/hr × 1.5hr/wk" : null;

    var gymAnnual =
      membershipAnnual + ptAnnual + travelAnnual + timeAnnual + childAnnual;
    var gymTotal = gymAnnual * years;
    var spdTotal = spdPrice();

    var save = Math.max(0, gymTotal - spdTotal);
    var savePm = save / (years * 12);
    var perPersonPm = spdTotal / (years * 12) / members;
    var brkMonths = gymAnnual > 0 ? Math.ceil(spdTotal / (gymAnnual / 12)) : 0;

    // Outputs
    if (O.vatBasis) O.vatBasis.textContent = vatBasisLabel();
    O.hero.textContent =
      "Save " + C0(save) + " over " + years + " year" + (years > 1 ? "s" : "");
    O.mon.textContent = C2(savePm) + " per month back";
    O.brk.textContent = "Break even: " + (brkMonths || "—") + " months";
    O.per.textContent =
      "Speediance ≈ " + C2(perPersonPm) + " per person monthly";

    var max = Math.max(spdTotal, gymTotal);
    O.barS.style.width = Math.max(8, Math.round((spdTotal / max) * 100)) + "%";
    O.barG.style.width = Math.max(8, Math.round((gymTotal / max) * 100)) + "%";
    O.vS.textContent = C0(spdTotal);
    O.vG.textContent = C0(gymTotal);

    O.tSpd.textContent = C0(spdTotal);
    O.tGym.textContent = C0(gymTotal);
    O.tSav.textContent = C0(save);

    var ptxt = years === 1 ? "1 year" : years + " years";
    O.p1.textContent = ptxt;
    O.p2.textContent = ptxt;
    O.p3.textContent = ptxt;
    O.modeLbl.textContent = mode === "pt" ? "Gym + PT" : "Gym only";
    O.barLbl.textContent = mode === "pt" ? "Gym + PT" : "Gym only";

    var parts = [
      "Gym membership: " + C0(membershipAnnual) + "/yr (" + members + "×)",
      mode === "pt" && ptPerW > 0 ? "PT: " + C0(ptAnnual) + "/yr" : null,
      travelDesc ? travelDesc + " → " + C0(travelAnnual) + "/yr" : null,
      timeDesc && timeOn ? timeDesc + " → " + C0(timeAnnual) + "/yr" : null,
      childDesc ? childDesc + " → " + C0(childAnnual) + "/yr" : null,
    ]
      .filter(Boolean)
      .join("  •  ");
    O.breakdown.textContent = parts;
  }

  function chipGroup(container, setter) {
    if (!container) return;
    container.addEventListener("click", function (e) {
      var b = e.target.closest(".chip");
      if (!b) return;
      e.preventDefault();
      setOn(container, b);
      setter(b);
    });
  }

  function setOn(container, btn) {
    container
      .querySelectorAll(".chip")
      .forEach((x) => x.classList.remove("is-on"));
    btn.classList.add("is-on");
  }

  function loadPreset(code) {
    var p = PRESETS[code] || PRESETS.EU;
    I.gym.value = p.gym;
    I.pt.value = p.pt;
    I.trips.value = p.trips;
    I.fare.value = p.fare;
    I.mins_pub.value = p.mins_pub;
    I.km.value = p.km;
    I.ppk.value = p.ppk;
    I.mins_car.value = p.mins_car;
    I.vhr.value = p.vhr;
    // Update helper lines in case you want to vary text per country later
    compute();
  }

  // Wire chip groups
  chipGroup(root.querySelector('[data-role="people"]'), (b) => {
    members = +b.dataset.m;
    compute();
  });
  chipGroup(root.querySelector('[data-role="mode"]'), (b) => {
    mode = b.dataset.mode;
    compute();
  });
  chipGroup(root.querySelector('[data-role="years"]'), (b) => {
    years = +b.dataset.y;
    compute();
  });
  chipGroup(root.querySelector('[data-role="time"]'), (b) => {
    // IMPRTANT: uncommit if we return time switcher;
    // timeOn = b.dataset.time === "on";
    timeOn = true;
    compute();
  });
  chipGroup(root.querySelector('[data-role="child"]'), (b) => {
    childcareOn = b.dataset.child === "on";
    compute();
  });
  // VAT basis has no local control any more: it follows the site-wide toggle.
  document.addEventListener("spx:vat:change", compute);
  document.addEventListener("spx:vat:ready", compute);

  chipGroup(I.trips, (b) => {
    tripsWk = +b.dataset.trip;
    compute();
  });

  chipGroup(I.ptw, (b) => {
    ptPerW = +b.dataset.ptw;
    compute();
  });

  // Country selector
  I.country.addEventListener("change", function () {
    loadPreset(this.value);
  });

  I.travel.addEventListener("change", function () {
    travel = this.value;
    showScope(travel);
    compute();
  });
  // Other inputs
  [
    "trips",
    "gym",
    "pt",
    "fare",
    "mins_pub",
    "km",
    "ppk",
    "mins_car",
    "vhr",
  ].forEach(function (name) {
    var el = root.querySelector('[name="' + name + '"]');
    if (!el) return;
    el.addEventListener("input", compute);
    el.addEventListener("change", compute);
  });

  // Init
  loadPreset("EU"); // default EU averages
  travel = I.travel.value;
  showScope(travel);

  compute();

  if (!customElements.get("speediance-calculator")) {
    class SpeedianceCalculator extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          stepBtn: null,
          stepCards: null,
          numberInputs: null, // To store all number inputs
        };
        this.currentStep = 1; // Steps are 1-based (e.g., Step 1, 2, 3)

        // Texts and classes for the button states
        this.btnTexts = {
          next: "Next",
          check: "Check Result",
          init: "Start Over",
        };
        this.btnClasses = {
          next: "button--gradient",
          init: "button--secondary",
        };

        // Bind 'this' for the event handler once
        this._handleStepChange = this._handleStepChange.bind(this);
        this._handleNumberInput = this._handleNumberInput.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      setupElements() {
        this.elements.stepBtn = this.querySelector(
          '[data-component="step-btn"]',
        );
        this.elements.stepCards = this.querySelectorAll(
          '[data-component="step"]',
        );

        this.elements.numberInputs = this.querySelectorAll(
          'input\[type="number"]',
        );

        if (!this.elements.stepBtn || this.elements.stepCards.length === 0) {
          console.error(
            "Calculator component is missing required elements (step button or step cards).",
          );
        }
      }

      addEventListeners() {
        if (this.elements.stepBtn) {
          this.elements.stepBtn.addEventListener(
            "click",
            this._handleStepChange,
          );
        }

        this.elements.numberInputs.forEach((input) => {
          input.addEventListener("input", this._handleNumberInput);
        });
      }

      removeEventListeners() {
        if (this.elements.stepBtn) {
          this.elements.stepBtn.removeEventListener(
            "click",
            this._handleStepChange,
          );
        }
      }

      /**
       *  Enforces the 'max' attribute on number inputs.
       * Prevents the user from manually typing a value greater than the max.
       */
      _handleNumberInput(event) {
        const input = event.target;
        const maxAttr = input.getAttribute("max");

        // Only proceed if a 'max' attribute exists.
        if (maxAttr === null || maxAttr === "") return;

        const maxValue = parseFloat(maxAttr);

        // If the input's value exceeds the max, set it to the max.
        if (parseFloat(input.value) > maxValue) {
          input.value = maxValue;
        }
      }

      /**
       * Main logic handler for the step button.
       * It either advances to the next step or resets the calculator.
       */
      _handleStepChange() {
        const totalSteps = this.elements.stepCards.length;

        // If we are on the last step, the button action is to reset
        if (this.currentStep === totalSteps) {
          this._reset();
        } else {
          // Otherwise, advance to the next step
          this.currentStep++;
          this._updateView();
        }
      }

      /**
       * Resets the calculator to the first step.
       */
      _reset() {
        this.currentStep = 1;
        this._updateView();
      }

      /**
       * Updates the DOM to reflect the current step.
       * This function handles card visibility and button state.
       */
      _updateView() {
        const totalSteps = this.elements.stepCards.length;
        const btn = this.elements.stepBtn;

        // Update visibility of the step cards
        this.elements.stepCards.forEach((card, index) => {
          // The index is 0-based, while currentStep is 1-based
          if (index + 1 === this.currentStep) {
            card.classList.add("current-step");
          } else {
            card.classList.remove("current-step");
          }
        });

        // Update the button's text and classes based on the new step
        btn.classList.remove(this.btnClasses.next, this.btnClasses.init);

        if (this.currentStep === totalSteps) {
          // We are now on the LAST step (the results)
          btn.innerHTML = `<span>${this.btnTexts.init}</span>`;
          btn.classList.add(this.btnClasses.init);
        } else if (this.currentStep === totalSteps - 1) {
          // We are now on the step BEFORE the results
          btn.innerHTML = `<span>${this.btnTexts.check}</span>`;
          btn.classList.add(this.btnClasses.next);
        } else {
          // We are on any other step
          btn.innerHTML = `<span>${this.btnTexts.next}</span>`;
          btn.classList.add(this.btnClasses.next);
        }
      }
    }

    customElements.define("speediance-calculator", SpeedianceCalculator);
  }
})();
